<template>
    <div class="progress-bar">
        <div class="progress-track">
            <a class="progress-item  progress-item--first" @click="setActiveStep(1)" v-bind:class="{'progress-current': step === 1, 'progress-reached': stepReached > 1}">
                <span class=""></span>
               Details
            </a>
            <a class="progress-item" @click="setActiveStep(2)" v-bind:class="{'progress-current': step === 2, 'progress-reached': stepReached > 2}">
                <span></span>
                Costs
            </a>
            <a class="progress-item  progress-item--last" @click="setActiveStep(3)" v-bind:class="{'progress-current': step === 3, 'progress-reached': stepReached > 3}">
                <span></span>
                Submit
            </a>
        </div>
    </div>
</template>

<script>
export default {
  name: 'progress-bar',
  props: ['step', 'stepReached'],
  data () {
    return {
      //
    }
  },
  methods: {
    //
    setActiveStep (step) {
      this.$store.commit('updateStep', step)
    }
  },
  computed: {
    //
  }
}
</script>
